import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import BiztantuConfirmDialog from '../../../Components/BiztantuConfirmDialog';
import { StyledFormContainer, StyledSubHeader } from '../../../Components/Styled';
import BiztantuFooterButton from '../../../Components/FotterButton';
import CreateSystemLookup from './CreateSystemLookup';
import ClientLookupTableV2 from './ClientLookupTableV2';
import { getOrderRequestData, updateOrderRequestData, updateRequestData, requestDeleteApiCall } from '../../../Utility/apiHelper';
import { useSnackbar } from 'notistack';
import BiztantuLoader from '../../../Components/Loader'
import { handleValidateCodevalue } from '../../../Utility/constant';
import { useDispatch, useSelector } from 'react-redux';
import { handleRequestGetAllLookup } from '../../../Store/lookup/action';
import LeadAccordion from '../../../Components/LeadAccordion';
export const LookupCreateEditScreen = ({currentActiveLookup, handleCustomBackbutton}) => {

    const internationalise = useSelector((state) => state?.internationalise?.currentHashMapData);
    const [lookupdetails, setlookupdetails] = useState({
        systemlookup: [],
        clientLookup: [],
        isClientLoader: false,
        isSystemLoader: false
    })
    
    const token = localStorage.getItem('accessToken');

    const [selectedClient, setSelectedClient] = useState(null);
    
    const {enqueueSnackbar} = useSnackbar();
    
        const currentUser = useSelector(state => state?.owner?.currentuser);
        const dispatch = useDispatch()

    useEffect(() => {
        if(currentActiveLookup?.activeLookupId) {
            handleGetAllrespectiveSystemLookup();
            handleSearchClient()
        }
    },[selectedClient])

    const handleGetAllrespectiveSystemLookup = async() => {
        
        setlookupdetails({
            ...lookupdetails,
            isSystemLoader: true,
        })
        const url = `${process.env.REACT_APP_LOOKUP_URL}lookup/system?lookupTypeId=${currentActiveLookup?.activeLookupId}`
        
        const response = await getOrderRequestData(url);
        if(response?.status >=200 && response?.status <=300 ){
        setlookupdetails(prev=>({
            ...prev,
            isSystemLoader: false,
            systemlookup: response?.data
        }))
    }
    }

    useEffect(()=>{
        setSelectedClient(currentUser?.selectedClient);
    },[currentUser])

    const handlebackbtn = () => {
        setlookupdetails({
            systemlookup: [],
            clientLookup: [],
            isClientLoader: false,
            isSystemLoader: false
        })

        handleCustomBackbutton();
        
    }

    const handleSearchClient = async() => {
       
        setlookupdetails(prev=>({
            ...prev,
            isClientLoader: true,
        }))

        const url = `${process.env.REACT_APP_LOOKUP_URL}lookup/client?lookupTypeId=${currentActiveLookup?.activeLookupId}&clientId=${currentUser?.client?.id}`
    
        const {data} = await getOrderRequestData(url);

        setlookupdetails(prev=>({
            ...prev,
            isClientLoader: false,
            clientLookup: data
        }))    
    }

    const handleGetAllrespectiveClientLookupCodes = () => {

    }

    const handleUpdaterecord = async(newdata, addeditsystemlookup) => {

        setlookupdetails({
            ...lookupdetails,
            isSystemLoader: true
        })
        const payload = {
          "lookupTypeId": currentActiveLookup?.lookupTypeName?.id,
          "lookupTypeName": currentActiveLookup?.lookupTypeName?.name,
          "sequence": parseInt(addeditsystemlookup?.sequence),
        "systemLookupCodeId": newdata?.id,
          "systemLookupCodeName": newdata?.name
        }

        if(newdata?.id) {
            const responseData = await updateOrderRequestData(payload, `${process.env.REACT_APP_LOOKUP_URL}lookup/system/updateLookupCode`);
    
    
            if(responseData?.status == 200) {
                await handleGetAllrespectiveSystemLookup()
                enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_UPDATED_SUCCESSFULLY"), {variant: 'success'})
                dispatch(handleRequestGetAllLookup(token, currentUser?.client?.id));
            } else {
              enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_PLEASE_TRY_AGAIN"), {variant: 'error'})
    
              setlookupdetails({
                ...lookupdetails,
                isSystemLoader: false
                })
            }
        } else {
            const responseData = await updateOrderRequestData(payload, `${process.env.REACT_APP_LOOKUP_URL}lookup/system/addLookupCode`);
    
    
            if(responseData?.status == 200) {
                await handleGetAllrespectiveSystemLookup()
                enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_CREATED_SUCCESSFULLY"), {variant: 'success'})
            } else {
              enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_PLEASE_TRY_AGAIN"), {variant: 'error'})
    
              setlookupdetails({
                ...lookupdetails,
                isSystemLoader: false
                })
            }
        }
        
    
      }

      const handleUpdateClinetlookup = async(newdata, selectedClient) => {
        
        setlookupdetails({
            ...lookupdetails,
            isClientLoader: true
        })

        const payload = {
            "clientId": selectedClient?.id,
            "clientLookupCodeId": newdata?.id,
            "clientLookupName": (newdata?.name || "").trim(),
            "lookupTypeId": currentActiveLookup?.lookupTypeName?.id,
            "status": newdata?.status,
            "lookupTypeName": currentActiveLookup?.lookupTypeName?.name,
            sequence: parseInt(newdata?.sequence),
            systemLookupCodeId: parseInt(
            lookupdetails?.systemlookup?.find(
                item => item?.name === newdata?.systemLookupCodeName
            )?.id
            ),
            systemLookupCodeName: newdata?.systemLookupCodeName

        }

        if (!newdata?.isNew) {
            const responseData = await updateOrderRequestData(payload, `${process.env.REACT_APP_LOOKUP_URL}lookup/client/updateLookupCode`);
    
            if (responseData?.status == 200) {
                await handleSearchClient();
                enqueueSnackbar(handleValidateCodevalue(internationalise, "COMMON_UPDATED_SUCCESSFULLY"), { variant: 'success' });
                dispatch(handleRequestGetAllLookup(token, currentUser?.client?.id));
                return { success: true };
            } else {
                const errorMsg = responseData?.propererror?.data?.message || responseData?.data?.message || "COMMON_PLEASE_TRY_AGAIN";
                enqueueSnackbar(handleValidateCodevalue(internationalise, errorMsg), { variant: 'error' });
    
                setlookupdetails({
                    ...lookupdetails,
                    isClientLoader: false
                });
                return { success: false, error: errorMsg };
            }
        } else {
            const { clientLookupCodeId, ...newPayload } = payload;
            const responseData = await updateOrderRequestData(newPayload, `${process.env.REACT_APP_LOOKUP_URL}lookup/client/addLookupCode`);
    
            if (responseData?.status == 200) {
                await handleSearchClient();
                enqueueSnackbar(handleValidateCodevalue(internationalise, "COMMON_CREATED_SUCCESSFULLY"), { variant: 'success' });
                dispatch(handleRequestGetAllLookup(token, currentUser?.client?.id));
                return { success: true };
            } else {
                const errorMsg = responseData?.propererror?.data?.message || responseData?.data?.message || "COMMON_PLEASE_TRY_AGAIN";
                enqueueSnackbar(handleValidateCodevalue(internationalise, errorMsg), { variant: 'error' });
    
                setlookupdetails({
                    ...lookupdetails,
                    isClientLoader: false
                });
                return { success: false, error: errorMsg };
            }
        }
        
      }

      const [deleteDialogState, setDeleteDialogState] = useState({
        open: false,
        clientLookupCodeId: null,
        clientLookupName: '',
        inUse: false,
        loading: false
      });

      const handleInitiateDeleteClientLookup = async (deleteId) => {
        try {
          const targetItem = lookupdetails?.clientLookup?.find((item) => item?.id == deleteId);
          setlookupdetails((prev) => ({ ...prev, isClientLoader: true }));
          const checkUrl = `${process.env.REACT_APP_LOOKUP_URL}lookup/client/isInUse?clientLookupCodeId=${deleteId}`;
          const response = await getOrderRequestData(checkUrl);
          const inUse = response?.data?.inUse || false;

          setDeleteDialogState({
            open: true,
            clientLookupCodeId: deleteId,
            clientLookupName: targetItem?.name || '',
            inUse,
            loading: false
          });
        } catch (error) {
          console.error("Error checking lookup in-use status", error);
          setDeleteDialogState({
            open: true,
            clientLookupCodeId: deleteId,
            clientLookupName: '',
            inUse: false,
            loading: false
          });
        } finally {
          setlookupdetails((prev) => ({ ...prev, isClientLoader: false }));
        }
      };

      const handleConfirmDelete = async () => {
        if (!deleteDialogState.clientLookupCodeId) return;
        try {
          setDeleteDialogState((prev) => ({ ...prev, loading: true }));
          setlookupdetails((prev) => ({ ...prev, isClientLoader: true }));

          const deleteUrl = `${process.env.REACT_APP_LOOKUP_URL}lookup/client/deleteLookupCode?clientLookupCodeId=${deleteDialogState.clientLookupCodeId}`;
          const responseData = await requestDeleteApiCall(deleteUrl);

          if (responseData?.status === 200 || responseData?.status === 204) {
            enqueueSnackbar(
              handleValidateCodevalue(internationalise, "COMMON_DELETED_SUCCESSFULLY"),
              { variant: 'success' }
            );
            await handleSearchClient();
            dispatch(handleRequestGetAllLookup(token, currentUser?.client?.id));
            setDeleteDialogState({ open: false, clientLookupCodeId: null, clientLookupName: '', inUse: false, loading: false });
          } else {
            enqueueSnackbar(
              handleValidateCodevalue(internationalise, "COMMON_PLEASE_TRY_AGAIN"),
              { variant: 'error' }
            );
            setDeleteDialogState((prev) => ({ ...prev, loading: false }));
          }
        } catch (error) {
          console.error("Error deleting client lookup code", error);
          enqueueSnackbar(
            handleValidateCodevalue(internationalise, "COMMON_PLEASE_TRY_AGAIN"),
            { variant: 'error' }
          );
          setDeleteDialogState((prev) => ({ ...prev, loading: false }));
        } finally {
          setlookupdetails((prev) => ({ ...prev, isClientLoader: false }));
        }
      };

      const handleCloseDeleteDialog = () => {
        if (deleteDialogState.loading) return;
        setDeleteDialogState({ open: false, clientLookupCodeId: null, clientLookupName: '', inUse: false, loading: false });
      };

      const handleReorderClientLookup = async (orderedIds) => {
        try {
          setlookupdetails((prev) => ({ ...prev, isClientLoader: true }));
          const payload = {
            lookupTypeId: currentActiveLookup?.lookupTypeName?.id,
            clientId: currentUser?.client?.id,
            orderedIds
          };
          const responseData = await updateOrderRequestData(
            payload,
            `${process.env.REACT_APP_LOOKUP_URL}lookup/client/reorderLookupCodes`
          );
          if (responseData?.status === 200) {
            await handleSearchClient();
            enqueueSnackbar(
              handleValidateCodevalue(internationalise, "COMMON_UPDATED_SUCCESSFULLY"),
              { variant: 'success' }
            );
            dispatch(handleRequestGetAllLookup(token, currentUser?.client?.id));
          } else {
            enqueueSnackbar(
              handleValidateCodevalue(internationalise, "COMMON_PLEASE_TRY_AGAIN"),
              { variant: 'error' }
            );
          }
        } catch (error) {
          console.error("Error reordering lookup codes", error);
          enqueueSnackbar(
            handleValidateCodevalue(internationalise, "COMMON_PLEASE_TRY_AGAIN"),
            { variant: 'error' }
          );
        } finally {
          setlookupdetails((prev) => ({ ...prev, isClientLoader: false }));
        }
      };

      const handleDeleteclientLookup = async(deleteId) => {
        try {

            setlookupdetails({
                ...lookupdetails,
                isClientLoader: true
            })

            const deleteData = lookupdetails?.clientLookup?.find(item => item?.id == deleteId);

            const payload = {
                "clientId": selectedClient?.companyId,
                "clientLookupCodeId": deleteId,
                "clientLookupName": deleteData?.name,
                "lookupTypeId": currentActiveLookup?.lookupTypeName?.id,
                "lookupTypeName": currentActiveLookup?.lookupTypeName?.name,
                "sequence": deleteData?.sequence,
                "status": deleteData?.status == 'ACTIVE' ? "INACTIVE" : "ACTIVE",
                "systemLookupCodeId": deleteData?.systemLookupCode?.id,
                "systemLookupCodeName": deleteData?.systemLookupCode?.name
            }



            const responseData = await updateRequestData(payload,`lookup/client/updateLookupCode`);

            if(responseData?.status == 200) {
                await handleSearchClient();
                if(deleteData?.status == "ACTIVE") {
                    enqueueSnackbar(handleValidateCodevalue(internationalise,"CLC_INACTIVATED_SUCCESSFULLY"), {variant: 'success'})
                    dispatch(handleRequestGetAllLookup(token, currentUser?.client?.id));
                } else {
                    enqueueSnackbar(handleValidateCodevalue(internationalise,"CLC_ACTIVATED_SUCCESSFULLY"), {variant: 'success'})
                }
              } else {
                    enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_PLEASE_TRY_AGAIN"), {variant: 'error'})
    
              setlookupdetails({
                ...lookupdetails,
                isClientLoader: false
                })
            }


        } catch(error) {
            setlookupdetails({
                ...lookupdetails,
                isClientLoader: false
            })
        }
      }

    return (
        
           
                        
        <>
            <Box sx={{backgroundColor: '#F4F9FE'}} className="lookup-create-edit-wrapper">
            <BiztantuLoader isChildren={true} open={lookupdetails?.isClientLoader || lookupdetails?.isSystemLoader}>
            <Box className="globalBox">
            <div 
            // style={{marginTop: "47px", marginLeft: "15px", padding: "10px"}}
            >
                <StyledFormContainer>
                    
                    <StyledSubHeader>
                  {handleValidateCodevalue(internationalise,'CONF_LU_EDIT_TYPE')} <Typography variant=''>{currentActiveLookup?.lookupTypeName?.name}</Typography>
                    </StyledSubHeader>
                </StyledFormContainer>

                <StyledFormContainer sx = {{padding: "0px",paddingLeft : "20px"}}>
                {/* <StyledSubHeader sx = {{margin: "0px 0px 0px 0px",paddingTop: "0px",}}>
                        {handleValidateCodevalue(internationalise,'CONF_LU_EDIT_SLC')}
                </StyledSubHeader> */}
                </StyledFormContainer>
            </div>
                <StyledFormContainer>
                     <LeadAccordion
                        label= {handleValidateCodevalue(internationalise,'CONF_LU_EDIT_SLC')}
                    >
                    <CreateSystemLookup
                        lookupdetails = {lookupdetails}
                        currentActiveLookup = {currentActiveLookup}
                        handleUpdateSystemrecord = {handleUpdaterecord}
                        enqueueSnackbar = {enqueueSnackbar}
                    />
                    </LeadAccordion>
                </StyledFormContainer>
                <StyledFormContainer>
                    <LeadAccordion
                        label={handleValidateCodevalue(internationalise, 'CONF_LU_EDIT_CLIENT_LU')}
                        defaultOpen={true}
                    >
                        <ClientLookupTableV2
                            lookupdetails={lookupdetails}
                            selectedClient={currentUser?.client}
                            clientName={currentUser?.client?.name}
                            currentUser={currentUser}
                            handleUpdateClinetlookup={handleUpdateClinetlookup}
                            handleDeleteclientLookup={handleInitiateDeleteClientLookup}
                            handleReorderClientLookup={handleReorderClientLookup}
                            enqueueSnackbar={enqueueSnackbar}
                        />
                    </LeadAccordion>
                </StyledFormContainer>

                {/* Delete Confirmation & Warning Dialog using LeadDialog style */}
                <BiztantuConfirmDialog
                    open={deleteDialogState.open}
                    onClose={handleCloseDeleteDialog}
                    onConfirm={handleConfirmDelete}
                    isWarning={deleteDialogState.inUse}
                    isAlertOnly={deleteDialogState.inUse}
                    title={
                      handleValidateCodevalue(internationalise, 'COMMON_CONFIRM_DELETE_TITLE')
                    }
                    confirmBtnLabel={
                        deleteDialogState.inUse
                            ? handleValidateCodevalue(internationalise, 'COMMON_CANCEL')
                            : handleValidateCodevalue(internationalise, 'COMMON_DELETE')
                    }
                    cancelBtnLabel={handleValidateCodevalue(internationalise, 'COMMON_CANCEL')}
                    loading={deleteDialogState.loading}
                    size="sm"
                >
                    <Typography gutterBottom sx={{ color: '#333', fontSize: '15px' }}>
                        {deleteDialogState.inUse
                            ? handleValidateCodevalue(internationalise, 'LU_IN_USE_DELETE_INFO')
                            : handleValidateCodevalue(internationalise, 'LU_CONFIRM_DELETE_INFO')}
                    </Typography>
                </BiztantuConfirmDialog>
                
             </Box>
             </BiztantuLoader>
             </Box>
            <BiztantuFooterButton 
                headerLabel= {handleValidateCodevalue(internationalise,'CONF_EDIT_LOOKUP')}
                isiconRequired={false}
                isBackbtnreq={true}
                handleCustomBackbutton={handlebackbtn}
                backButtonLabel={handleValidateCodevalue(internationalise,'COMMON_BACK')}
                redirecturl=""
            />

        </>
    )
}


export default LookupCreateEditScreen;
